// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","back":"header_back__wgjRV","rotate":"header_rotate__XmwxF"};